<template>
  <div
    class="comp-container__header"
    :class="{
      'comp-container__header-win': isElectron && isWin,
      'comp-container__header-mac': isElectron && !isWin,
    }"
    @dblclick="onDblclick"
  >
    <div class="content-container">
      <div class="menu-left">
        <div class="network menu-item">
          <wifi></wifi>
        </div>
        <div class="share menu-item">
          <share></share>
        </div>
        <div class="network menu-item">
          <live-info></live-info>
        </div>
        <div class="share menu-item">
          <el-tooltip effect="dark" content="刷新" placement="top-start">
            <img
              src="@saas/pages/assets/images/live/refresh.png"
              alt=""
              @click="handleRefreshPage"
            />
          </el-tooltip>
        </div>
        <div class="duration menu-item">
          <live-duration></live-duration>
        </div>
      </div>
      <div class="content-center">
        <el-tooltip
          v-if="!roomInfo.isStudent"
          class="item"
          effect="dark"
          :content="'分别代表在线人数及课堂总人数'"
          placement="top"
        >
          <span style="-webkit-app-region: none">
            {{ roomInfo.room_name || "-" }}（{{ onlineCount }}/{{
              roomInfo.enrollment_count || 0
            }}）
          </span>
        </el-tooltip>
        <span v-else>{{ roomInfo.room_name || "-" }}</span>
      </div>
      <div class="menu-right">
        <re-record v-if="!roomInfo.isStudent"></re-record>
        <layout-popover></layout-popover>
        <div @click="showSetting" class="menu-item grid">
          <img src="@saas/pages/assets/images/live/setting.png" alt="" />
          <span>设置</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import Share from "./Share.vue";
import Wifi from "./Wifi.vue";
import LayoutPopover from "./LayoutPopover.vue";
import LiveDuration from "./LiveDuration.vue";
import ReRecord from "./ReRecord.vue";
import LiveInfo from "./LiveInfo.vue";
import {
  isAssistant,
  isTeacher,
  isWhiteboardAndRecord,
} from "../utils/index.js";
import { forceFlushLogs } from "@saas/components/src/utils/log";
export default {
  props: {
    isWin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Share,
    Wifi,
    LayoutPopover,
    LiveDuration,
    ReRecord,
    LiveInfo,
  },
  data() {
    return {
      // 课堂总人数（不包含老师，助教）
      totalCount: 0,
      // 在线人数 不包含老师，助教
      onlineCount: 0,
      isElectron: window.isElectron,
    };
  },
  beforeDestroy() {
    this.liveService.off("remoteUserEnterRoom", this.onRemoteUserEnterRoom);
    this.liveService.off("remoteUserLeaveRoom", this.onRemoteUserLeaveRoom);
  },
  mounted() {},
  computed: {
    ...mapState("live", [
      "cameraList",
      "liveService",
      "microphoneList",
      "speakerList",
      "layout",
      "roomInfo",
      "whiteBoardService",
    ]),
    userInfo() {
      return this.$store.getters.user || {};
    },
    // 最多拖堂时长
    maxDelayDuration() {
      return this.roomInfo.end_delay_time;
    },
  },
  watch: {
    liveService: {
      handler(val) {
        console.log("service>>>", val);
        if (val) {
          this.liveService.on(
            "remoteUserEnterRoom",
            this.onRemoteUserEnterRoom
          );
          this.liveService.on(
            "remoteUserLeaveRoom",
            this.onRemoteUserLeaveRoom
          );
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("live", ["setLayout", "setOnlineCount", "setIsDelay"]),
    onDblclick() {
      if (this.isElectron) {
        window.LiveElectronApi.toggleMaxSize();
      }
    },
    // 有人进入房间
    onRemoteUserEnterRoom(res) {
      console.log("onRemoteUserEnterRoom>>>header", res);
      if (res) {
        const { userID } = res;
        if (
          !isTeacher(userID, this.roomInfo) &&
          !isAssistant(userID, this.roomInfo) &&
          !isWhiteboardAndRecord(userID)
        ) {
          // 学生进入房间
          this.onlineCount++;
          this.setOnlineCount(this.onlineCount);
        }
      }
    },
    onRemoteUserLeaveRoom(res) {
      if (res) {
        const { userID } = res;
        if (
          !isTeacher(userID, this.roomInfo) &&
          !isAssistant(userID, this.roomInfo) &&
          !isWhiteboardAndRecord(userID)
        ) {
          // 学生离开房间
          if (this.onlineCount <= 0) {
            return;
          }
          this.onlineCount--;
          this.setOnlineCount(this.onlineCount);
        }
      }
    },
    showSetting() {
      uploadLiveLog({
        message: "用户点击头部设置按钮",
        extra: {
          component: "Header",
          action: "click_header_setting",
        },
      });

      this.$emit("showSetting");
    },
    handleRefreshPage() {
      uploadLiveLog({
        message: "用户点击头部刷新按钮",
        extra: {
          component: "Header",
          action: "click_header_refresh",
        },
      });
      forceFlushLogs().finally(() => {
        if (window.isElectron && window.ipcRenderer) {
          window.ipcRenderer.send("chat-close-window");
        }
        window.location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container__header {
  width: 100%;
  height: $live-room-header-height;
  border-radius: 0px 0px 0px 0px;
  padding: 0 20px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  border-bottom: none;
  color: #fff;
  &.comp-container__header-win {
    padding-right: 128px;
  }
  &.comp-container__header-mac {
    padding-left: 90px;
  }
  .content-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .menu-left,
    .menu-right {
      flex: 3;
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
      }
      .menu-item {
        -webkit-app-region: none;
      }
    }
    .menu-left {
      justify-content: flex-start;
      .network,
      .share {
        width: 20px;
        height: 20px;
        cursor: pointer;
        margin-right: 8px;
        margin-bottom: 2px;
      }
    }
    .menu-right {
      justify-content: flex-end;
      .menu-item {
        display: flex;
        align-items: center;
        flex-direction: row;
        cursor: pointer;
        margin-left: 12px;
        img {
          width: 20px;
          height: 20px;
        }
        span {
          margin-left: 3px;
          font-weight: 400;
          font-size: 12px;
          color: #c9cdd4;
        }
      }
    }
    .content-center {
      flex: 5;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #ecedee;
    }
  }
}
</style>
